import { render } from "./UserTransfers.vue?vue&type=template&id=2b46b865&scoped=true"
import script from "./UserTransfers.vue?vue&type=script&lang=js"
export * from "./UserTransfers.vue?vue&type=script&lang=js"

import "./UserTransfers.vue?vue&type=style&index=0&id=2b46b865&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b46b865"]])

export default __exports__